module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/schedule_intro-3108ae116b9e9fc975227b80fdf17e42.jpg";